<template>
  <v-btn-toggle class="justify-center">
    <v-btn
        icon
        :href="`https://t.me/share/url?url=${shareUrl}`"
        target="_blank"
    >
      <img width="25" src="../assets/telegram-4.png" alt="">
    </v-btn>
    <v-btn
        icon
        :href="`https://twitter.com/intent/tweet?text=${shareUrl}`"
        target="_blank"
    >
      <v-icon color="#000">mdi-twitter</v-icon>
    </v-btn>

    <v-btn
        icon
        :href="`https://wa.me/?text=${shareUrl}`"
        target="_blank"
    >
      <img width="25" src="../assets/whatsapp_1.png" alt="">
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  props: { profile: Object },
  computed: {
    shareUrl() {
      return "https://simiaroom.com/legendary-therapists";
    },
  },
};
</script>
